import ko from "knockout";

var GraphFeature = function (name, id, isSelected, selectedFeatures, variableSelectionUpdateTrigger) {
  var self = this;
  self.name = name;
  self.id = id;
  self.isSelected = ko.observable(isSelected);
  self.queue = selectedFeatures.includes(id.toString()) ? selectedFeatures.indexOf(id.toString()) : 0;
  self.tooltipText = ko.observable("<p>Feature<br>Standardized name in Fleet Insights</p>");

  self.select = function (variable) {
    self.queue = selectedFeatures.length;
    self.isSelected(true);
    selectedFeatures.push(variable.id.toString());
    if (variableSelectionUpdateTrigger) { variableSelectionUpdateTrigger.notifySubscribers(); }
  };

  self.unselect = function (_) {
    self.isSelected(false);
    if (variableSelectionUpdateTrigger) { variableSelectionUpdateTrigger.notifySubscribers(); }
  };
};

export default GraphFeature;
